<template>
  <div class="relative max-w-3xl w-full py-2 group ">
    <div>
      <input
        v-model="currentValue"
        type="range"
        :step="step"
        :min="min"
        :max="max"
        class="absolute z-40 h-2 w-full cursor-pointer appearance-none opacity-0"
      >

      <div class="relative z-10 h-2">
        <div class="absolute z-10 left-0 right-0 bottom-0 top-0 rounded-md bg-gray-100 dark:bg-gray-800" />

        <div
          class="absolute z-20 top-0 left-0 bottom-0 rounded-md bg-blue-300"
          :style="{
            width: `calc(${thumb}% + 4px) !important`
          }"
        />

        <div
          class="absolute z-30 w-4 h-4 top-1/2 transform -translate-y-1/2 -translate-x-1/2 left-0 bg-blue-400 rounded-full"
          :style="{
            left: `${thumb}% !important`
          }"
        >
          <div class="bg-gray-800 opacity-0 group-hover:opacity-85 py-1 px-2 text-white text-sm rounded absolute bottom-full transform left-1/2 -translate-x-1/2 mb-2 transition-opacity">
            {{ label }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  modelValue: number | string
  min?: number
  max?: number
  step?: number
  labels?: Record<string, any> | null
}

const props = withDefaults(defineProps<Props>(), {
  min: 0,
  max: 10000,
  step: 1,
  labels: null,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: number): void
}>()

const currentValue = computed({
  get () {
    return props.modelValue
  },
  set (value: any) {
    emit('update:modelValue', Number(value))
  },
})

const thumb = computed(() => {
  return ((Number(currentValue.value) - props.min) / (props.max - props.min)) * 100
})

const label = computed(() => {
  return props.labels ? props.labels[currentValue.value] : currentValue.value
})
</script>

<style>
input[type=range]::-webkit-slider-thumb {
  pointer-events: all;
  width: 24px;
  height: 24px;
  -webkit-appearance: none;
}
</style>
